<template>
  <div class="not-found">
    <h1>404</h1>
    <p>not found</p>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.not-found {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  text-align: center;
  background-color: #f8f9fa;
}

h1 {
  font-size: 120px;
  margin: 0;
  color: #343a40;
  font-weight: bold;
}

p {
  font-size: 24px;
  color: #6c757d;
  margin: 20px 0;
}

/* .home-link {
  display: inline-block;
  padding: 12px 24px;
  background-color: #007bff;
  color: white;
  text-decoration: none;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.home-link:hover {
  background-color: #0056b3;
} */
</style>